import { ReservationTypeWithColor } from '../../hooks/AppData/useReservationTypes';
import { FormValidators, VALIDATION_MESSAGES } from '../../hooks/useForm';
import { Branch } from '../../types/branch';
import { Organization } from '../../types/organization';
import { ReservationHours } from '../../types/reservationType';

const { NOT_EMAIL } = VALIDATION_MESSAGES;

// Branch settings form
export interface BranchSettingsForm {
  name?: string;
  city?: string;
  color?: string;
}
export const getBranchSettingsFormValidators = (hasSignedDocumentsFeature: boolean): FormValidators<BranchSettingsForm> => {
  return {
    name: (form) => {
      if (!form.name) return 'El nombre es requerido';
    },
    city: (form) => {
      if (hasSignedDocumentsFeature && !form.city) return 'La ubicación de los documentos firmados es requerida';
    },
  };
};
export const getInitialBranchSettingsForm = (branch: Branch | undefined): BranchSettingsForm => {
  const { name, city, color } = branch ?? {};
  return {
    name: name ?? '',
    city: city ?? '',
    color: color ?? '#000000',
  };
};

// Reservation hours form
interface BranchReservationHours {
  hours: ReservationHours;
  closedDays: Date[];
}
export interface ReservationHoursForm {
  [key: string]: BranchReservationHours;
}
export const getInitialReservationHoursForm = (
  branchReservationTypes: ReservationTypeWithColor[] | undefined,
): ReservationHoursForm | undefined => {
  return branchReservationTypes?.reduce<ReservationHoursForm>((acc, reservationType) => {
    acc[reservationType.id] = {
      hours: reservationType.hours,
      closedDays: reservationType.closedDays.map((date) => new Date(date)) || [],
    };
    return acc;
  }, {});
};
export const RESERVATION_HOURS_FORM_VALIDATORS: FormValidators<ReservationHoursForm> = {};

// Org email settings form
export interface OrgEmailSettingsForm {
  emailLocalPart?: string;
  emailDomain?: string;
}
export const ORG_EMAIL_SETTINGS_FORM_VALIDATORS: FormValidators<OrgEmailSettingsForm> = {
  emailLocalPart: (form) => {
    if (!form.emailLocalPart) return NOT_EMAIL;
  },
};
export const getInitialOrgEmailSettingsForm = (org?: Organization): OrgEmailSettingsForm => {
  const { email } = org ?? {};
  const atIndex = email?.indexOf('@');
  const emailLocalPart = atIndex && atIndex >= 0 ? email?.substring(0, atIndex) : email;
  const emailDomain = atIndex && atIndex >= 0 ? email?.substring(atIndex) : undefined;
  return {
    emailLocalPart: emailLocalPart,
    emailDomain: emailDomain,
  };
};
